// components/UpdatePersonPicture/UpdatePersonPicture.tsx
import { Button } from "components/Button/Button";
import { FileInput } from "components/FileInput/FileInput";
import { Toast } from "components/ToastShow/ToastAlert";
import { Loading } from "components/Loading/loading";
import { useState, useEffect, useContext } from "react";
import {
  updatePersonPicture,
  getUserInfoForm,
  deletePersonPicture,
} from "../api";
import { ENDPOINTS } from "utils/endpoints";
import { MessageType } from "types/enum";
import { trans } from "utils/helpers";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";

interface UpdatePersonPictureProps {
  hide?: (bool) => void;
  mode?: string;
  onSuccess?: () => void;
}

export const UpdatePersonPicture: React.FC<UpdatePersonPictureProps> = ({
  hide,
  mode = "edit",
  onSuccess,
}) => {
  const [selectedImage, setSelectedImage] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  let layoutContext = useContext(LayoutContext);

  const [dataChange, setDataChange] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [currentUserData, setCurrentUserData] = useState<any>(null);

  // دریافت اطلاعات فعلی کاربر
  const getUserDataAsync = async () => {
    setLoading(true);
    try {
      const response = await getUserInfoForm();
      setCurrentUserData(response.Data);
    } catch (error) {}
    setLoading(false);
  };

  // تغییر تصویر
  const changeHandlePic = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const imageData = {
        Url: URL.createObjectURL([...e.target.files][0]),
        File: [...e.target.files][0],
      };
      setSelectedImage(imageData);
      setDataChange(true);
    }
  };

  // آپلود تصویر
  const updatePersonPictureAsync = async (data: FormData) => {
    try {
      const response = await updatePersonPicture(data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  const handleDelete = async (event: React.FormEvent) => {
    Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete, async () => {
      try {
        const response = await deletePersonPicture();
        layoutContext.setPicturePerson(null);
        hide && hide(true);
      } catch (error) {
        throw error;
      }
    });
  };

  // ارسال فرم
  const formSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!selectedImage?.File) {
      return;
    }

    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("personPicture", selectedImage.File);

      await updatePersonPictureAsync(formData);

      if (onSuccess) {
        onSuccess();
      }

      if (hide) {
        hide(true);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  };

  // حذف تصویر انتخاب شده
  const clearSelectedImage = () => {
    setSelectedImage(null);
    setDataChange(false);
  };

  useEffect(() => {
    getUserDataAsync();
  }, []);

  if (loading) {
    return (
      <div className="card p-3">
        <Loading />
      </div>
    );
  }

  return (
    <div className="card p-3">
      <form className="card-body" onSubmit={formSubmit}>
        <div className="row ">
          <div className="col-12 col-md-6">
            <FileInput
              showBox={true}
              maxWidth={1000}
              maxHeight={1000}
              maxSize={25600000}
              defultFileName="profilePicture.jpg"
              hideSrc={false}
              endpoint={ENDPOINTS.secretariat.indicator.attachmentFile}
              id={currentUserData?.LetterDefaultAttachmentId}
              lable="ProfilePicture"
              name="profilePicture"
              onChange={changeHandlePic}
              src={
                selectedImage
                  ? selectedImage.Url
                  : layoutContext.picturePerson
                  ? "data:image/png;base64," + layoutContext.picturePerson
                  : ""
              }
            />
          </div>
        </div>
        <div className="row ">
          <div className="col-12 d-flex justify-content-end">
            {mode !== "view" ? (
              <>
                <Button
                  btnType="submit"
                  value={submitting ? "Uploading..." : "Upload"}
                  disabled={!dataChange || submitting}
                />
                <Button
                  btnType="cancel"
                  value="Cancel"
                  onClick={() => {
                    if (dataChange) {
                      Toast(
                        trans("modalclosemessage"),
                        MessageType.confirm,
                        hide || (() => {})
                      );
                    } else {
                      hide && hide(false);
                    }
                  }}
                />
              </>
            ) : (
              <Button
                btnType="primary"
                value="Close"
                onClick={hide || (() => {})}
              />
            )}
            {layoutContext.picturePerson && (
              <Button
                btnType="cancelFill"
                value={"حذف عکس پروفایل"}
                onClick={handleDelete}
              />
            )}
          </div>
        </div>
      </form>
    </div>
  );
};
